import React from 'react';
import './DeliveryMode.css';
import { Link } from 'react-router-dom';

// Import the images you saved
import webAppImg from '../../assets/images/delivery-webapp.png';
import emailImg from '../../assets/images/delivery-email.png';
import whatsappImg from '../../assets/images/delivery-whatsapp.png';

// Import a cloud/API icon from the library
import { FaCloudUploadAlt } from 'react-icons/fa';

// Array of data for our delivery mode cards
const deliveryData = [
  {
    type: 'image',
    content: webAppImg,
    title: 'Website & mobile app'
  },
  {
    type: 'image',
    content: emailImg,
    title: 'Email'
  },
  {
    type: 'icon',
    content: <FaCloudUploadAlt />,
    title: 'API mode'
  },
  {
    type: 'image',
    content: whatsappImg,
    title: 'Whatsapp'
  }
];

const DeliveryMode = () => {
  return (
    <section className="delivery-section">
      <div className="section-header">
        <h2>Delivery Mode</h2>
        <div className="header-line"></div>
      </div>
      <p className="section-subtitle">
        Easy access to crucial information; when you need it, where you need it
      </p>

      <div className="delivery-grid">
        {deliveryData.map((item, index) => (
           <Link to="/delivery-mode" key={index} className="delivery-card-link">
          <div className="delivery-card">
            {/* This container will now hold both the circle and the image/icon */}
            <div className="delivery-image-wrapper">
              <div className="delivery-background-circle"></div>
              {item.type === 'image' ? 
                <img src={item.content} alt={item.title} className="delivery-image" /> : 
                <div className="delivery-icon">{item.content}</div>
              }
            </div>
            <h3>{item.title}</h3>
          </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default DeliveryMode;